import * as React from 'react'
import { cn } from '@/lib/utils'

/** Shared look for text-like controls (Input, Select, Textarea). */
export const controlClassName =
  'w-full rounded-md border border-input bg-card text-control text-foreground shadow-card transition-colors placeholder:text-tertiary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-60 aria-invalid:border-danger'

/** A styled text input. Height follows density (32px compact, 40px comfortable). */
export function Input({ ref, className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      className={cn('flex h-control px-control-x py-1', controlClassName, className)}
      ref={ref}
      {...props}
    />
  )
}
